import React from 'react'
import { Flag } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'

type Props = {
  className?: string
}
/**
 * Tag a sale line item as a special order product
 */
export const SpecialOrderProductTagLegacy = (props: Props) => {
  const t = useT()
  return (
    <div
      className={props.className ?? ''}
      data-testid="special-order-product-tag"
    >
      <Flag
        content={t('SPECIAL ORDER PRODUCT', {
          _context: 'Tagging a product as a special order product',
        })}
      />
    </div>
  )
}
